import React from "react";
import { AuthProvider } from "./AuthContext";
import { ProfileProvider } from "./ProfileContext";
import { ChatProvider } from "./ChatContext";
import { SidebarProvider } from "./SidebarContext";

export const AppContextProvider = ({ children }) => {
    return (
        <AuthProvider>
            <ProfileProvider>
                <SidebarProvider>
                    <ChatProvider>{children}</ChatProvider>
                </SidebarProvider>
            </ProfileProvider>
        </AuthProvider>
    );
};
